import "../styles/cards.scss"

export function HomeCard1(props) {
    return(
        <div className="homeCard1" onClick={props.onClick}>
            <div className="orange"></div>
            <div className="homeCard1Card">
                <div className="homeCard1Img">
                <img src={props.img}/>
                </div>
                <div className="homeCard1Title">{props.title}</div>
                <div className="homeCard1Text"> {props.text}</div>
            </div>
        </div>
    )
}